import styled from 'styled-components';
import { Link } from 'gatsby';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import { mb, pt } from '@upgrade/react-components/Spacing/core';
import { Row } from '@upgrade/react-components';
import { Text } from '../common/TypographyPublicSite';

export const BlogPostsRow = styled(Row)`
  flex-wrap: nowrap;
  overflow: hidden;

  @media (min-width: ${props => props.theme.mediaSm}) {
    flex-wrap: wrap;
  }
`;

export const BlogCategoryNavText = styled(Text)`
  letter-spacing: 0.0625rem;

  @media (min-width: ${props => props.theme.mediaSm}) {
    letter-spacing: 0.075rem;
  }
`;

export const TitleLink = styled(Link)`
  display: block;

  p {
    ${mb('none')};
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
    line-height: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.lineHeight};
    font-weight: 500;
  }

  .fluid-img {
    transition: transform 0.2s ease-in-out;
  }

  &,
  &:hover {
    text-decoration: none;
  }
  &:hover {
    div {
      background-size: 120%;
      &:after {
        opacity: 0.7;
      }
    }
    .fluid-img {
      transform: scale(1.2);
      &:after {
        opacity: 0.7;
      }
    }
  }
`;

export const PreviewImage = styled.div`
  display: block;
  position: relative;
  width: 100%;
  ${mb('xs')};
  height: 6rem;

  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100%;
  background-image: url(${({ 'data-image': img }) => img});
  transition: background-size 0.2s ease-in-out;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.accentPrimary1};
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  @media (min-width: ${props => props.theme.mediaSm}) {
    height: 10rem;
  }
`;

export const FluidWrapper = styled.div`
  overflow: hidden;
  ${mb({ xs: 'none', sm: 'md' })};
  height: 6rem;
  display: flex;
  align-items: center;

  @media (min-width: ${props => props.theme.mediaSm}) {
    height: 10rem;
  }
`;

export const GatsbyImg = styled(Img)`
  width: 100%;
  transition: transform 0.2s ease-in-out;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.accentPrimary1};
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
`;

export const Post = styled.div`
  border-top: 1px solid ${props => props.theme.palette.border};
  ${pt('xl')};
  img,
  iframe {
    height: auto;
    max-width: 100%;
    ${mb('xl')};
  }
  hr {
    ${mb('xl')};
  }
  table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
    ${mb('lg')};
  }
  td {
    padding: 0.625rem;
  }
  tbody > tr:nth-of-type(odd) {
    background-color: ${props => props.theme.palette.backgroundPage};
  }
`;

export const SearchField = styled.form`
  display: flex;
  > :first-child {
    flex: 1 1 auto;
  }
  > button {
    border-radius: 0 ${props => props.theme.defaultBorderRadius} ${props => props.theme.defaultBorderRadius} 0;
    position: relative;
    left: -2px;
  }
`;
